module.exports = __webpack_public_path__ + "mo/img/piece-16.152b0d1f.svg";